import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LOCALE_CONFIG } from '@/consts/common';

// - Keep English as the source in public/locales/en/*.json
// - Add matching files for each language (fr, es, etc.) under public/locales/<lng>/
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: LOCALE_CONFIG.SUPPORTED_LANGUAGES[0],
    supportedLngs: LOCALE_CONFIG.SUPPORTED_LANGUAGES,
    load: 'languageOnly',
    ns: [LOCALE_CONFIG.NAMESPACES[0], LOCALE_CONFIG.NAMESPACES[1]],
    defaultNS: LOCALE_CONFIG.NAMESPACES[0],
    backend: {
      loadPath: '/static/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string): string => {
        // Extract base language code (strip region codes like -CA, -US, etc.)
        const baseLanguage = lng.split('-')[0].toLowerCase();
        // Check if the normalized language is supported
        const { SUPPORTED_LANGUAGES } = LOCALE_CONFIG;
        if (SUPPORTED_LANGUAGES.includes(baseLanguage as typeof SUPPORTED_LANGUAGES[number])) {
          return baseLanguage;
        }
        // Return fallback language if not supported
        return LOCALE_CONFIG.SUPPORTED_LANGUAGES[0];
      },
    },
    react: {
      useSuspense: true,
    },
    interpolation: {
      // Avoid passing t() output or interpolated values into dangerouslySetInnerHTML
      // (or similar raw HTML APIs) without sanitization; doing so can introduce XSS vulnerabilities
      escapeValue: false,
    },
  });

export default i18n;
